module.exports = __webpack_public_path__ + "static/media/PierSans-Regular.239bd637.otf";